import { useState, useEffect, useContext, useCallback } from 'react';
import { Helmet } from 'react-helmet-async';
import { useParams } from 'react-router-dom';
import { filter } from 'lodash';
import { sentenceCase } from 'change-case';
// @mui
import {
  Card,
  Table,
  Stack,
  Paper,
  TextField,
  Button,
  Popover,
  Checkbox,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  IconButton,
  TableContainer,
  TablePagination,
  Select,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from '@mui/material';
import DoneIcon from '@mui/icons-material/Done';
// components
import Label from '../components/label';
import Iconify from '../components/iconify';
import Scrollbar from '../components/scrollbar';
// sections
import { UserListHead, UserListToolbar } from '../sections/@dashboard/user';

import { EntityContext } from '../entity';

import { SignerCard } from '../components/signer-input'

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: 'name', label: 'Nome', alignRight: false },
  { id: 'email', label: 'Email', alignRight: false },
  { id: 'documentNumber', label: 'Numero de documento', alignRight: false },
  { id: 'role', label: 'Papel', alignRight: false },
  { id: 'required', label: 'Obrigatorio', alignRight: false },
  { id: 'createdAt', label: 'Data de criação', alignRight: false },
  { id: '' },
];

// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(array, (_user) => _user.name.toLowerCase().indexOf(query.toLowerCase()) !== -1);
  }
  return stabilizedThis.map((el) => el[0]);
}

const AddSignerCard = (props) => {
  return (
    <Stack justifyContent="space-between" mb={5}>
      <Card>
        <Typography sx={{ m: 2 }} >Novo Assinante</Typography>
        <Stack direction="row" alignItems="center" justifyContent="center" useFlexGap flexWrap="wrap">
          <TextField
            name="documentNumber"
            label="Numero do Documento"
            value={props.signerDocumentNumber}
            type="tel"
            error={props.documentNumberError}
            helperText={props.documentNumberError ? 'Documento inválido' : ''}
            onChange={props.handleDocumentNumberChange}
            inputProps={{ maxLength: 11 }}
          />
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            label="Papel"
            value={props.roleType}
            onChange={e => props.setRoleType(e.target.value)}
          >
            <MenuItem value={'signer'}>Assinante</MenuItem>
            <MenuItem value={'observer'}>Observador</MenuItem>
          </Select>
        </Stack>
        <Stack direction="row" alignItems="center" justifyContent="center" useFlexGap flexWrap="wrap">
          <Checkbox label="Required" checked={props.required} disabled={props.roleType === 'observer'} onChange={_ => props.handleChangeRequired()} />
          <Typography>Obrigatorio</Typography>
          <Button
            sx={{ m: 2 }}
            variant="contained"
            component="label"
            startIcon={<Iconify icon="eva:plus-fill" />}
            onClick={_ => props.vinculateSigner()}>
            Adicionar
          </Button>
        </Stack>
      </Card>
    </Stack>
  )
}

export default function GroupEditPage() {

  const { groupKey } = useParams();

  const [groupName, setGroupName] = useState('')
  const [signersMinimum, setSignersMinimum] = useState(0)

  const [signerGroupList, setSignerGroupList] = useState([]);
  const [signerKey, setSignerKey] = useState(null)
  const [editGroup, setEditGroup] = useState(false)

  const [signerDocumentNumber, setSignerDocumentNumber] = useState('')
  const [roleType, setRoleType] = useState('signer');
  const [required, serRequired] = useState(false);

  const [showAddSigner, setShowAddSigner] = useState(false);
  const [newUserDocumentNumber, setNewUserDocumentNumber] = useState('');

  const [open, setOpen] = useState(null);
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState('name');
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const [documentNumberError, setDocumentNumberError] = useState(false)

  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false)
  const [signerToDelete, setSignerToDelete] = useState(null)

  const { getGroup, getSignerByDocument, vinculateSignerToGroup, editGroupApi, deleteSignerFromGroup } = useContext(EntityContext)

  const handleDocumentNumberChange = (event) => {
    const formattedDocumentNumber = event.target.value.replace(/\D/g, ''); // Remove non-digits

    // Ensure length is exactly 11 for valid CPF
    const isValid = formattedDocumentNumber.length === 11;
    setSignerDocumentNumber(formattedDocumentNumber);
    setDocumentNumberError(!isValid);
  };

  const handleChangeRequired = () => {
    // Observers não podem ser required
    if (roleType === 'observer') {
      return;
    }
    serRequired(!required);
  };

  useEffect(() => {
    getSignnersList()
  }, [])

  const getSignnersList = useCallback(async () => {

    getGroup(groupKey)
      .then((data) => {
        setSignerGroupList(data.members)
        setGroupName(data.group.group_name)
        setSignersMinimum(data.group.signers_minimum)

      })

  }, [])

  const vinculateSigner = async () => {

    getSignerByDocument(signerDocumentNumber)
      .then((data) => {
        vinculateSignerToGroup(groupKey, data.signer_key, roleType, required)
          .then((data) => {

            getSignnersList()
            setSignerDocumentNumber('')
            serRequired(false)
            setRoleType('signer')
            setShowAddSigner(false)
          })
      })



  }

  const handleOpenMenu = (event) => {
    setOpen(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setOpen(null);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = signerGroupList.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    }
    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
    setRowsPerPage(parseInt(event.target.value, 10));
  };

  const handleFilterByName = (event) => {
    setPage(0);
    setFilterName(event.target.value);
  };

  const handleToggleAddUser = () => {
    setShowAddSigner(!showAddSigner)
  }

  const handleEditGroup = () => {
    editGroupApi(groupKey, signersMinimum, groupName)
      .then((data) => {
        setEditGroup(!editGroup)
        getSignnersList()
      })
  }

  const handleOpenDeleteDialog = (signer) => {
    setSignerToDelete(signer)
    setDeleteDialogOpen(true)
  }

  const handleCloseDeleteDialog = () => {
    setDeleteDialogOpen(false)
    setSignerToDelete(null)
  }

  const handleConfirmDelete = () => {
    if (signerToDelete) {
      deleteSignerFromGroup(groupKey, signerToDelete.signer_key)
        .then((data) => {
          setPage(0)
          getSignnersList()
          handleCloseDeleteDialog()
        })
        .catch((error) => {
          console.error('Error deleting signer:', error)
          handleCloseDeleteDialog()
        })
    }
  }

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - signerGroupList.length) : 0;

  const filteredUsers = applySortFilter(signerGroupList, getComparator(order, orderBy), filterName);

  const isNotFound = !filteredUsers.length && !!filterName;

  return (
    <>
      <Helmet>
        <title> Grupos </title>
      </Helmet>

      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Grupo: {groupKey}
          </Typography>
        </Stack>

        <Stack justifyContent="space-between" mb={5}>
          <Card>
            <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ p: 3 }} useFlexGap flexWrap="wrap">
              <Typography variant="h4" gutterBottom mb={0.2}>
                Nome:
              </Typography>
              <TextField sx={{ m: 2 }}
                id="outlined-basic"
                variant="outlined"
                disabled={!editGroup}
                onChange={e => {
                  const val = e.target.value;
                  setGroupName(val);
                }}
                value={groupName} />
              <Typography variant="h4" gutterBottom mb={0.2} >
                Minimo de Assinantes:
              </Typography>
              <TextField sx={{ m: 2 }}
                id="outlined-basic"
                variant="outlined"
                disabled={!editGroup}
                onChange={e => setSignersMinimum(e.target.value)}
                value={signersMinimum} />
            </Stack>
            <Stack
              direction="row"
              p={2}
              sx={{
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {editGroup ?
                <Button size="large" color="success" variant='contained' onClick={_ => handleEditGroup()} >
                  <DoneIcon /> Concluir
                </Button> :
                <Button size="large" color="primary" variant='contained' onClick={_ => setEditGroup(!editGroup)}>
                  <Iconify icon={'eva:edit-fill'} />Editar
                </Button>}
            </Stack>
          </Card>
        </Stack>

        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Assinantes
          </Typography>
          <Button variant="contained" startIcon={<Iconify icon="eva:plus-fill" />} onClick={handleToggleAddUser}>
            Adicionar Assinante
          </Button>
        </Stack>

        {showAddSigner ?
          <Stack justifyContent="space-between" mb={5}>
            <AddSignerCard signerDocumentNumber={signerDocumentNumber}
              handleDocumentNumberChange={handleDocumentNumberChange}
              roleType={roleType} setRoleType={setRoleType}
              required={required} handleChangeRequired={handleChangeRequired}
              vinculateSigner={vinculateSigner} documentNumberError={documentNumberError} />
          </Stack> : <></>}

        <Card>
          <UserListToolbar numSelected={selected.length} filterName={filterName} onFilterName={handleFilterByName} />

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <UserListHead
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  rowCount={signerGroupList.length}
                  numSelected={selected.length}
                  onRequestSort={handleRequestSort}
                  onSelectAllClick={handleSelectAllClick}
                  showCheckbox={false}
                />
                <TableBody>
                  {filteredUsers.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                    return (
                      <TableRow hover key={row.id} tabIndex={-1}>
                        <TableCell component="th" scope="row" padding="normal">
                          <Stack direction="row" alignItems="center" spacing={2}>
                            <Typography variant="subtitle2" noWrap>
                              {row.signer_name}
                            </Typography>
                          </Stack>
                        </TableCell>

                        <TableCell align="left">{row.signer_email}</TableCell>

                        <TableCell align="left">{row.signer_document_number}</TableCell>

                        <TableCell align="left">{row.role_type}</TableCell>

                        <TableCell align="left">{row.required ?
                          <Label>Sim</Label> : <Label>Não</Label>
                        }</TableCell>

                        <TableCell align="left">{row.created_at.substring(0, 10).concat(' ').concat(row.created_at.substring(11, 19))}</TableCell>

                        <TableCell align="right">
                          <IconButton size="large" color="error" onClick={() => handleOpenDeleteDialog(row)}>
                            <Iconify icon={'eva:trash-2-outline'} />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                  {emptyRows > 0 && (
                    <TableRow style={{ height: 53 * emptyRows }}>
                      <TableCell colSpan={7} />
                    </TableRow>
                  )}
                </TableBody>

                {isNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={7} sx={{ py: 3 }}>
                        <Paper
                          sx={{
                            textAlign: 'center',
                          }}
                        >
                          <Typography variant="h6" paragraph>
                            Not found
                          </Typography>

                          <Typography variant="body2">
                            No results found for &nbsp;
                            <strong>&quot;{filterName}&quot;</strong>.
                            <br /> Try checking for typos or using complete words.
                          </Typography>
                        </Paper>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={signerGroupList.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>
      </Container>

      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            p: 1,
            width: 140,
            '& .MuiMenuItem-root': {
              px: 1,
              typography: 'body2',
              borderRadius: 0.75,
            },
          },
        }}
      >
        <MenuItem>
          <Iconify icon={'eva:edit-fill'} sx={{ mr: 2 }} />
          Edit
        </MenuItem>

        <MenuItem sx={{ color: 'error.main' }}>
          <Iconify icon={'eva:trash-2-outline'} sx={{ mr: 2 }} />
          Delete
        </MenuItem>
      </Popover>

      <Dialog
        open={deleteDialogOpen}
        onClose={handleCloseDeleteDialog}
        aria-labelledby="delete-dialog-title"
        aria-describedby="delete-dialog-description"
      >
        <DialogTitle id="delete-dialog-title">
          Confirmar Exclusão
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="delete-dialog-description">
            Tem certeza que deseja excluir o assinante <strong>{signerToDelete?.signer_name}</strong> do grupo?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDeleteDialog} color="inherit">
            Cancelar
          </Button>
          <Button onClick={handleConfirmDelete} color="error" variant="contained" autoFocus>
            Sim, excluir
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
